export default {
    enter: 13,
    tab: 9
};
